export default __webpack_public_path__ + "static/amazon_msk-ed8c5521a17a44fc7f4a25c370b75223.svg";